(function () {
  'use strict';

  var existing = window.EFGDualShippingBars;
  if (existing && typeof existing.refresh === 'function') {
    existing.refresh();
    return;
  }

  var configElement = document.getElementById('efg-dual-shipping-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    console.warn('[EFG shipping progress] Invalid configuration.', error);
    return;
  }

  var liveThreshold = Math.max(0, Number(config.liveThreshold) || 19900);
  var liveBestThreshold = Math.max(liveThreshold, Number(config.liveBestThreshold) || 29900);
  var dryThreshold = Math.max(0, Number(config.dryThreshold) || 5000);
  var dryGoodsIds = new Set((config.dryGoodsProductIds || []).map(String));
  var serviceHandles = new Set((config.serviceHandles || []).map(normalize));
  var serviceProductType = normalize(config.serviceProductType || 'Shop Service');
  var state = {
    timer: null,
    retryTimer: null,
    running: false,
    pending: false,
    lastModel: null,
    errorLogged: false
  };
  var moneyFormatters = new Map();

  if (Number(config.dryGoodsAllProductsCount) > dryGoodsIds.size) {
    console.warn('[EFG shipping progress] The Dry Goods collection is larger than its serialized product list.');
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function findSupercart() {
    return document.querySelector('#supercart.supercart-main') || document.querySelector('.supercart-main#supercart');
  }

  function createWidget() {
    var widget = document.createElement('section');
    widget.id = 'efg-dual-shipping-progress';
    widget.className = 'efg-shipping-progress';
    widget.setAttribute('data-efg-owner', 'theme');
    widget.setAttribute('aria-label', 'Shipping rewards progress');
    widget.hidden = true;
    widget.innerHTML =
      '<div class="efg-shipping-progress__heading"><span>Shipping rewards</span></div>' +
      '<div class="efg-shipping-progress__meter" data-efg-meter="live" hidden>' +
        '<div class="efg-shipping-progress__meta">' +
          '<span class="efg-shipping-progress__category">Live fish</span>' +
          '<span class="efg-shipping-progress__percent" data-efg-percent>0%</span>' +
        '</div>' +
        '<p class="efg-shipping-progress__message" data-efg-message aria-live="polite"></p>' +
        '<div class="efg-shipping-progress__track-wrap">' +
          '<div class="efg-shipping-progress__track" data-efg-progress role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
            '<span class="efg-shipping-progress__fill" data-efg-fill></span>' +
          '</div>' +
          '<span class="efg-shipping-progress__milestone efg-shipping-progress__milestone--first" data-efg-live-milestone aria-hidden="true"></span>' +
          '<span class="efg-shipping-progress__milestone efg-shipping-progress__milestone--best" aria-hidden="true"></span>' +
        '</div>' +
        '<div class="efg-shipping-progress__goals" aria-hidden="true">' +
          '<span data-efg-live-first-goal></span>' +
          '<span data-efg-live-best-goal></span>' +
        '</div>' +
      '</div>' +
      '<div class="efg-shipping-progress__meter" data-efg-meter="dry" hidden>' +
        '<div class="efg-shipping-progress__meta">' +
          '<span class="efg-shipping-progress__category">Dry goods</span>' +
          '<span class="efg-shipping-progress__percent" data-efg-percent>0%</span>' +
        '</div>' +
        '<p class="efg-shipping-progress__message" data-efg-message aria-live="polite"></p>' +
        '<div class="efg-shipping-progress__track" data-efg-progress role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
          '<span class="efg-shipping-progress__fill" data-efg-fill></span>' +
        '</div>' +
      '</div>';
    return widget;
  }

  function ensureMounted(supercart) {
    var ownedWidgets = Array.from(document.querySelectorAll('#efg-dual-shipping-progress[data-efg-owner="theme"]'));
    var widget = ownedWidgets.find(function (candidate) {
      return supercart.contains(candidate);
    });

    ownedWidgets.forEach(function (candidate) {
      if (candidate !== widget) candidate.remove();
    });

    if (!widget) widget = createWidget();

    var header = supercart.querySelector('.supercart-header');
    var host = supercart.querySelector('.section-top-section') ||
      supercart.querySelector('.supercart-inner') ||
      supercart.querySelector('.supercart-panel') ||
      supercart;

    if (header && header.parentElement) {
      if (header.nextElementSibling !== widget) header.insertAdjacentElement('afterend', widget);
    } else if (widget.parentElement !== host || host.firstElementChild !== widget) {
      host.prepend(widget);
    }

    return widget;
  }

  function getFormatter(currency, fractionDigits) {
    var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var digits = fractionDigits === 0 ? 0 : 2;
    var key = code + '|' + digits;
    if (moneyFormatters.has(key)) return moneyFormatters.get(key);

    var formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });
    } catch (error) {
      formatter = {
        format: function (amount) {
          return '$' + amount.toFixed(digits);
        }
      };
    }
    moneyFormatters.set(key, formatter);
    return formatter;
  }

  function formatMoney(cents, currency) {
    var safeCents = Math.max(0, Math.round(Number(cents) || 0));
    var fractionDigits = safeCents % 100 === 0 ? 0 : 2;
    return getFormatter(currency, fractionDigits).format(safeCents / 100);
  }

  function lineCents(item) {
    var value = Number(item.final_line_price);
    if (!Number.isFinite(value)) value = Number(item.line_price);
    if (!Number.isFinite(value)) {
      value = Number(item.final_price) * Math.max(0, Number(item.quantity) || 0);
    }
    return Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
  }

  function buildModel(cart) {
    var model = {
      currency: cart.currency || 'USD',
      liveSubtotal: 0,
      drySubtotal: 0,
      liveQuantity: 0,
      dryQuantity: 0
    };

    (cart.items || []).forEach(function (item) {
      var quantity = Math.max(0, Number(item.quantity) || 0);
      if (!quantity) return;

      var handle = normalize(item.handle);
      var productType = normalize(item.product_type);
      var isService = serviceHandles.has(handle) ||
        productType === serviceProductType ||
        item.requires_shipping === false;

      if (isService) return;

      var amount = lineCents(item);
      if (dryGoodsIds.has(String(item.product_id))) {
        model.drySubtotal += amount;
        model.dryQuantity += quantity;
      } else {
        model.liveSubtotal += amount;
        model.liveQuantity += quantity;
      }
    });

    model.hasLive = model.liveQuantity > 0;
    model.hasDry = model.dryQuantity > 0;
    model.signature = [
      model.currency,
      model.liveSubtotal,
      model.drySubtotal,
      model.liveQuantity,
      model.dryQuantity
    ].join('|');
    return model;
  }

  function updateMeter(widget, key, present, spent, threshold, currency) {
    var meter = widget.querySelector('[data-efg-meter="' + key + '"]');
    if (!meter) return;

    meter.hidden = !present;
    if (!present) return;

    var isLive = key === 'live';
    var goal = isLive ? liveBestThreshold : threshold;
    var complete = spent >= goal;
    var firstComplete = isLive && spent >= threshold;
    var progress = goal > 0 ? Math.min(100, Math.max(0, (spent / goal) * 100)) : 100;
    var message;

    if (isLive) {
      if (complete) {
        message = 'Best overnight shipping rate unlocked.';
      } else if (firstComplete) {
        message = 'Discounted overnight shipping unlocked. Add ' +
          formatMoney(liveBestThreshold - spent, currency) +
          ' more in live fish for our best rate.';
      } else if (spent > 0) {
        message = 'You\u2019re ' + formatMoney(threshold - spent, currency) +
          ' away from discounted overnight shipping.';
      } else {
        message = 'Add ' + formatMoney(threshold, currency) +
          ' in live fish to unlock discounted overnight shipping.';
      }

      var milestone = meter.querySelector('[data-efg-live-milestone]');
      var milestonePosition = liveBestThreshold > 0
        ? Math.min(100, Math.max(0, (threshold / liveBestThreshold) * 100))
        : 100;
      meter.style.setProperty('--efg-live-first-position', milestonePosition.toFixed(2) + '%');
      if (milestone) milestone.style.left = milestonePosition.toFixed(2) + '%';

      var firstGoal = meter.querySelector('[data-efg-live-first-goal]');
      var bestGoal = meter.querySelector('[data-efg-live-best-goal]');
      if (firstGoal) firstGoal.textContent = formatMoney(threshold, currency) + ' discounted';
      if (bestGoal) bestGoal.textContent = formatMoney(liveBestThreshold, currency) + ' best rate';
    } else {
      message = complete
        ? 'Free ground shipping unlocked for dry goods.'
        : (spent > 0
          ? 'You\u2019re ' + formatMoney(threshold - spent, currency) +
            ' away from free ground shipping.'
          : 'Add ' + formatMoney(threshold, currency) +
            ' in dry goods to unlock free ground shipping.');
    }

    meter.classList.toggle('is-first-complete', firstComplete);
    meter.classList.toggle('is-complete', complete);
    meter.querySelector('[data-efg-message]').textContent = message;
    meter.querySelector('[data-efg-percent]').textContent = Math.round(progress) + '%';
    meter.querySelector('[data-efg-fill]').style.width = progress.toFixed(2) + '%';

    var progressElement = meter.querySelector('[data-efg-progress]');
    progressElement.setAttribute('aria-valuenow', String(Math.round(progress)));
    progressElement.setAttribute('aria-valuetext', message);
  }

  function updateCalendar(supercart, hasLive) {
    supercart.setAttribute('data-efg-shipping-ready', 'true');
    supercart.setAttribute('data-efg-has-live', String(hasLive));
    supercart.querySelectorAll('super-date-picker').forEach(function (picker) {
      picker.hidden = !hasLive;
      picker.setAttribute('aria-hidden', String(!hasLive));
    });
  }

  function render(model) {
    var supercart = findSupercart();
    if (!supercart) return;

    var widget = ensureMounted(supercart);
    widget.hidden = false;
    widget.setAttribute('aria-hidden', 'false');

    updateMeter(widget, 'live', true, model.liveSubtotal, liveThreshold, model.currency);
    updateMeter(widget, 'dry', true, model.drySubtotal, dryThreshold, model.currency);
    updateCalendar(supercart, model.hasLive);
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  async function sync() {
    if (state.running) {
      state.pending = true;
      return;
    }

    state.running = true;
    try {
      var response = await fetch(cartUrl(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart request failed with ' + response.status);

      var cart = await response.json();
      var model = buildModel(cart);
      state.lastModel = model;
      state.errorLogged = false;
      render(model);
    } catch (error) {
      if (!state.errorLogged) {
        console.warn('[EFG shipping progress] Cart refresh failed.', error);
        state.errorLogged = true;
      }
      if (state.lastModel) render(state.lastModel);
    } finally {
      state.running = false;
      if (state.pending) {
        state.pending = false;
        queueSync(0);
      }
    }
  }

  function queueSync(delay) {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      state.timer = null;
      sync();
    }, typeof delay === 'number' ? delay : 140);
  }

  function queueBurst() {
    queueSync(120);
    window.clearTimeout(state.retryTimer);
    state.retryTimer = window.setTimeout(function () {
      queueSync(0);
    }, 700);
  }

  function mutationTouchesSupercart(record) {
    var target = record.target && record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target && target.closest && target.closest('#efg-dual-shipping-progress')) return false;
    if (target && target.closest && target.closest('#supercart')) return true;

    return Array.from(record.addedNodes || []).concat(Array.from(record.removedNodes || [])).some(function (node) {
      return node.nodeType === 1 && (
        (node.matches && node.matches('#supercart, #supercart *')) ||
        (node.querySelector && node.querySelector('#supercart'))
      );
    });
  }

  var observer = new MutationObserver(function (records) {
    if (!records.some(mutationTouchesSupercart)) return;
    if (state.lastModel) render(state.lastModel);
    queueSync(160);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    var action = form ? (form.getAttribute('action') || '') : '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) queueBurst();
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('#supercart') && !target.closest('#efg-dual-shipping-progress')) {
      queueBurst();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('#efg-dual-shipping-progress, super-date-picker')) return;

    var supercartAction = target.closest('#supercart button, #supercart a');
    var addToCartAction = target.closest('button[name="add"], [data-add-to-cart], form[action*="/cart/add"] button[type="submit"]');
    if (supercartAction || addToCartAction) queueBurst();
  }, true);

  ['cart:updated', 'cart:update', 'cart:refresh', 'shopify:section:load'].forEach(function (eventName) {
    document.addEventListener(eventName, queueBurst);
  });

  window.addEventListener('pageshow', function () { queueSync(0); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') queueSync(0);
  });

  window.EFGDualShippingBars = {
    version: config.version || '1.0.0',
    refresh: function () { queueSync(0); }
  };

  queueSync(0);
})();
